import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      light: "#e5e5e5",
      main: "#01305F",
      dark: "#01305F",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff5e50",
      main: "#d2d4d5",
      dark: "#bec0c1",
      contrastText: "#000",
    },
  },
});

export default theme;

